<template>
  <section ref="strip" class="s-car-sales">
    <div class="s-car-sales__results">
      <!--#region s-car-sales__sort-->
      <div class="s-car-sales__sort">
        <div class="b-vehicleSorting">
          <div class="b-vehicleSorting__orderBy">
            <div class="b-lbl-inpt b-lbl-inpt--lg-inline">
              <label>{{ dictionary.sortLabel }}</label>

              <div class="input-wrap">
                <select
                  id="selectSortBy"
                  v-model="sortBy"
                  class="form-select"
                  @change="onChangeSortBy">
                  <option
                    v-for="(item, index) in sortByOptions"
                    :key="index"
                    :value="item.value">
                    {{ item.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="b-vehicleSorting__foundPages">
            <span>
              {{ recordsCountFiltered }} {{ dictionary.totalResultsSuffix }}
            </span>

            <span v-if="showPagination">
              &nbsp;| {{ itemsPerPage }} {{ dictionary.itemsPerPageSuffix }}
            </span>
          </div>
          <div
            v-if="showPagination"
            class="b-vehicleSorting__btn"
            data-v-if="showPagination">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="onClickShowAll">
              {{ dictionary.buttonShowAllText }}
            </button>
          </div>
        </div>
      </div>

      <div class="s-car-sales__vehicles">
        <div class="s-car-sales__vehicles__results mb-40">
          <div
            v-for="item in recordsFilteredPaged"
            :key="item.id"
            class="s-car-sales__vehicles__item">
            <CarSalesVehicle :item="item" />
          </div>
        </div>

        <div v-if="!recordsCountFiltered">
          <NoResults></NoResults>
        </div>

        <div v-if="recordsCountFiltered" class="d-flex justify-content-center">
          <Pagination
            :total-records="recordsCountFiltered"
            :per-page="itemsPerPage"
            :current-page="page"
            @pagechanged="pageChanged" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import jQuery from 'jquery'
import NoResults from '../components/common/NoResults.vue'
import Pagination from './../components/common/Pagination.vue'
import * as lib from '../../lib/lib'
import CarSalesVehicle from './../components/CarSalesVehicle.vue'
import { v4 as uuidv4 } from 'uuid'
/* eslint-disable no-unused-vars */
import { extend, orderBy } from 'lodash'

export default {
  components: { NoResults, Pagination, CarSalesVehicle },
  data() {
    return {
      sortByOptions: [],
      sortBy: '',

      page: 1,
      pageSize: 9,
      itemsPerPage: 0,

      records: [],
      recordsCount: null,
      recordsFiltered: [],
    }
  },
  computed: {
    showPagination() {
      return this.itemsPerPage < 999
    },
    recordsFilteredPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage

      return this.recordsFiltered.slice(start, end)
    },

    recordsCountFiltered() {
      return this.recordsFiltered.length
    },
  },
  mounted() {
    const { sortByOptions, CarSalesList } = lib.getData('carSalesData')

    this.sortByOptions = sortByOptions
    this.itemsPerPage = this.configuration.itemsPerPage
    this.setPreselectedValues()

    /* eslint-disable no-undef */
    this.records = this.recordsFiltered = CarSalesList.map((x, index) =>
      _.extend({}, x, { id: uuidv4(), index: index })
    )
  },
  methods: {
    setPreselectedValues() {
      const entry = this.sortByOptions.find((i) => i.selected)
      this.sortBy = entry ? entry.value : ''
    },

    onClickShowAll() {
      this.page = 1
      this.itemsPerPage = 999
    },

    pageChanged(value) {
      this.page = value
      lib.scrollToElem(jQuery(this.$refs.strip), 100)
    },

    onChangeSortBy() {
      console.log('test', this.sortBy)
      this.page = 1

      let sortProperty = null
      let sortOrder = null

      switch (this.sortBy) {
        case 'priceAsc':
          sortProperty = ['Price']
          sortOrder = ['asc']
          break
        case 'priceDesc':
          sortProperty = ['Price']
          sortOrder = ['desc']
          break
        default:
          sortProperty = ['index']
          sortOrder = ['asc']
      }

      /* eslint-disable no-undef */
      this.recordsFiltered = _.orderBy(
        this.recordsFiltered,
        sortProperty,
        sortOrder
      )
    },
  },
}
</script>
